"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _strings = _interopRequireDefault(require("./constants/strings"));
var _utils = require("./utils");
var _Grid = _interopRequireDefault(require("./styles/Grid"));
var _excluded = ["className", "items", "noItemsText", "children", "uniformRows", "footerChildren", "element"];
var Grid = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var className = props.className,
    items = props.items,
    _props$noItemsText = props.noItemsText,
    noItemsText = _props$noItemsText === void 0 ? true : _props$noItemsText,
    children = props.children,
    _props$uniformRows = props.uniformRows,
    uniformRows = _props$uniformRows === void 0 ? false : _props$uniformRows,
    _props$footerChildren = props.footerChildren,
    footerChildren = _props$footerChildren === void 0 ? null : _props$footerChildren,
    element = props.element,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var ListElement = element !== null && element !== void 0 ? element : 'ul';
  var passedNothing = !items;
  var hasItems = !passedNothing && items.length > 0;
  var displayNoItemsText = !!noItemsText;
  var noItemsTextToRender = (0, _utils.isString)(noItemsText) ? noItemsText : _strings["default"].noItemsAvailable;
  return /*#__PURE__*/_react["default"].createElement(ListElement, (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('mko-grid', [_Grid["default"].grid, uniformRows && _Grid["default"].grid_uniformRows, className])
  }, other), !passedNothing && !hasItems && displayNoItemsText && /*#__PURE__*/_react["default"].createElement("li", {
    key: "NONE",
    className: (0, _classnames["default"])('mko-grid__no-items', _Grid["default"].grid__noItems)
  }, noItemsTextToRender), hasItems && children && props.items.map(children), footerChildren);
});
Grid.displayName = 'Grid';
var _default = exports["default"] = Grid;